import localStorageStore from '../../../store/localStorageStore';
import type { IssueStartResult, IssueTakeOverResult, LandingRecord } from '../types/domain.types';

import { CTL_ENDPOINTS } from './endpoints';
import { CtlApiError } from './errors';
import { createCtlClient } from './http';
import { issueClaimsWith } from './issues.api';
import { landingRecordSchema, parseOrThrow } from './schemas';

const { request } = createCtlClient({ onSessionLost: () => localStorageStore.logout() });

const GONE: ReadonlySet<number> = new Set([404, 410]);
const SESSION_REFUSED = 401;

export const isLandingGone = (error: unknown): boolean => error instanceof CtlApiError && GONE.has(error.status);

export const isSessionRefused = (error: unknown): boolean => error instanceof CtlApiError && error.status === SESSION_REFUSED;

export const fetchLanding = async (token: string, signal: AbortSignal | undefined): Promise<LandingRecord> => {
  const raw = await request('get', CTL_ENDPOINTS.LANDING(token), { signal });
  return parseOrThrow(landingRecordSchema, raw, 'landing record');
};

const landingClaims = issueClaimsWith({ request });

export const startFromLanding = (issueId: string, token: string): Promise<IssueStartResult> => landingClaims.start(issueId, 'LANDING', token);

export const takeOverFromLanding = (issueId: string, token: string): Promise<IssueTakeOverResult> =>
  landingClaims.takeOver(issueId, 'LANDING', token);
